// Guest-only progress stored in the browser (no account required, no personal data).
const KEY = "lumora_progress_v1";

function read() {
  try {
    return JSON.parse(localStorage.getItem(KEY)) || {};
  } catch {
    return {};
  }
}

function write(data) {
  try {
    localStorage.setItem(KEY, JSON.stringify(data));
  } catch {
    /* storage unavailable — progress simply won't persist */
  }
}

export function getProgress() {
  const d = read();
  return {
    lessons: d.lessons || {}, // slug -> { completed: bool, updatedAt }
    stories: d.stories || {}, // slug -> { readPct: number }
    games: d.games || {}, // id -> { bestScore }
  };
}

export function isLessonComplete(slug) {
  return !!getProgress().lessons[slug]?.completed;
}

export function completeLesson(slug) {
  const d = read();
  d.lessons = d.lessons || {};
  d.lessons[slug] = { completed: true, updatedAt: Date.now() };
  write(d);
}

export function setStoryProgress(slug, readPct) {
  const d = read();
  d.stories = d.stories || {};
  d.stories[slug] = { readPct: Math.max(readPct, d.stories[slug]?.readPct || 0) };
  write(d);
}

export function getStoryProgress(slug) {
  return getProgress().stories[slug]?.readPct || 0;
}

export function recordGameScore(id, score) {
  const d = read();
  d.games = d.games || {};
  const best = Math.max(score, d.games[id]?.bestScore || 0);
  d.games[id] = { bestScore: best };
  write(d);
  return best;
}

export function getGameBest(id) {
  return getProgress().games[id]?.bestScore || 0;
}

export function countCompletedLessons() {
  const lessons = getProgress().lessons;
  return Object.values(lessons).filter((l) => l.completed).length;
}
